import { useIsLoggedIn } from '@cp/entities/currentUser';
import { currentClientFavoriteApi } from '@cp/entities/client/current/favorite/api/api';
import { useEffect, useMemo } from 'react';
import { useFavoritesService } from './useFavoritesService';
import { useFavorites } from './useFavorites';

type FavoritesQueryParams = {
  refetchOnMountOrArgChange?: boolean;
  refetchOnFavoritesChange?: boolean;
};

export const useQueryFavorites = (options?: FavoritesQueryParams) => {
  const isLoggedIn = useIsLoggedIn();
  const stateFavorites = useFavorites();
  const favoritesService = useFavoritesService();
  const favoritesDependence = options?.refetchOnFavoritesChange ? stateFavorites : [];
  const clientIds = useMemo<number[]>(() => {
    const storageFavorites = favoritesService.getFavorites();
    return storageFavorites as number[];
  }, [favoritesService, favoritesDependence.join()]);
  const { data: favorites, isLoading: isFavoritesLoading } = currentClientFavoriteApi.endpoints.getFavoriteClientsList.useQuery(
    { clientIds },
    options,
  );
  useEffect(() => {
    if (favorites && isLoggedIn) {
      favoritesService.deleteFavorites();
    }
  }, [favorites, favoritesService, isLoggedIn]);
  return { favorites, isFavoritesLoading };
};
